var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"shellImage"},[_vm._l((_vm.sources),function(source,i){return _c('source',_vm._b({key:i},'source',source,false))}),_c('img',_vm._b({attrs:{"loading":_vm.loading}},'img',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }